import { MdlDialogReference } from '@angular-mdl/core';
import { ChangeDetectionStrategy, Component, Inject, InjectionToken } from '@angular/core';
import { StudyGroupInfo } from '../group-info/study-group-info';
import { SampleTrackingDialogResult, SampleTrackingResultAction } from '../service/dialog-service/sample-tracking-result';
import { ActivityLogger } from '../../activities/activity-logger';

export const STUDY_GROUP_VIEW_TOKEN = new InjectionToken('StudyGroupViewItem');

@Component({
    selector: 'view-study-group',
    template: require('./view-study-group.component.html'),
    styles: [require('./view-study-group.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ViewStudyGroupComponent  {

    public studyGroup = new StudyGroupInfo();

    constructor(private dialog: MdlDialogReference,
                activityLogger: ActivityLogger,
                @Inject(STUDY_GROUP_VIEW_TOKEN) private readonly studyGroupInfo: StudyGroupInfo) {

        this.studyGroup = studyGroupInfo;

        activityLogger.logActivity('View Study Group - Sample Tracking');
    }

    public close() {
        const result: SampleTrackingDialogResult = {
            action: SampleTrackingResultAction.close
        };
        this.dialog.hide(result);
    }

    public async deleteGroup() {
        const result: SampleTrackingDialogResult = {
            action: SampleTrackingResultAction.delete,
            groupPk: this.studyGroupInfo.groupPk
        };

        this.dialog.hide(result);
    }

    public async editGroup() {
        const result: SampleTrackingDialogResult = {
            action: SampleTrackingResultAction.edit,
        };

        this.dialog.hide(result);
    }
}